'use strict';

const Config = {
  StaticResourcesBucketURL: 'https://storage.googleapis.com/atria-static-resources',
};

/** @type {import('tailwindcss').Config} */
var tailwind_config = {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  theme: {
    extend: {
      fontFamily: {
        display: ['Ivar Display', 'sans-serif'],
        body: ['Scto Grotesk', 'sans-serif'],
      },
      transitionTimingFunction: {
        global: 'cubic-bezier(0.65, 0, 0.35, 1)',
      },
      backgroundImage: {
        'noise-fern': `url(${Config.StaticResourcesBucketURL}/images/noise-fern.svg)`,
        'noise-sage': `url(${Config.StaticResourcesBucketURL}/images/noise-sage.svg)`,
        'noise-moss': `url(${Config.StaticResourcesBucketURL}/images/noise-moss.svg)`,
        'noise-kelp-600': `url(${Config.StaticResourcesBucketURL}/images/noise-kelp-600.svg)`,
        ellipsis: `url(${Config.StaticResourcesBucketURL}/images/ellipsis.svg)`,
        circles: `url(${Config.StaticResourcesBucketURL}/images/circles.svg)`,
        squares: `url(${Config.StaticResourcesBucketURL}/images/squares.svg)`,
        texture: `url(${Config.StaticResourcesBucketURL}/images/texture.svg)`,
        'double-circle': `url(${Config.StaticResourcesBucketURL}/images/double-circle.svg)`,
        'stone-texture': `url(${Config.StaticResourcesBucketURL}/images/stones/stone-texture.png)`,
      },
      boxShadow: {
        default: '0px 11px 17.8px 0px rgba(218, 218, 218, 0.24)',
      },
      colors: {
        sage: '#869D89',
        fern: '#607663',
        moss: '#506653',
        kelp: {
          dark: '#334534',
        },
        'neue-kelp': {
          100: '#98B2A8',
          200: '#577A6D',
          300: '#42685A',
          400: '#344740',
          500: '#2D3F39',
          600: '#273933',
        },
        'neue-stone': {
          100: '#F9F8F6',
          200: '#F2F1EE',
          300: '#E7E4DF',
          400: '#DCD8D0',
          500: '#CBC6BD',
        },
        forest: {
          100: '#3C4E3D',
          200: '#334534',
          300: '#2D3C2D',
        },
        sand: {
          100: '#F8F7F5',
          200: '#F4F1EE',
          300: '#E7E4DF',
          400: '#DCD8D0',
          500: '#CBC6BD',
        },
        white: '#FFF',
        gray: {
          100: '#F2F2F2',
          200: '#E8E8E8',
          300: '#D0D0D0',
          400: '#B8B8B8',
          500: '#757575',
          600: '#646464',
        },
        'off-black': '#231F20',
        rust: {
          DEFAULT: '#a25b4c',
          100: '#E7D4C6',
          200: '#C99287',
          300: '#A25B4C',
          400: '#5C3E37',
        },
        coast: {
          100: '#E7D4C6',
          200: '#C99287',
          300: '#A25B4C',
          400: '#5C3E37',
        },
      },
    },
  },
  plugins: [],
};

module.exports = tailwind_config;
